import { db } from '../firebase';
import { collection, doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { getEffectiveUserId } from './userService';

const parametersCollection = collection(db, "userSettings");

// Récupérer les paramètres de l'utilisateur effectif
export const fetchUserParameters = async () => {
  const userId = await getEffectiveUserId();
  if (!userId) {
    throw new Error("Utilisateur non connecté");
  }

  const docRef = doc(parametersCollection, userId);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data() || {};
  } else {
    // Si aucun paramètre n'existe, créer un document par défaut
    const defaultParameters = {
      userId: userId,
      startMinute: 480, // 08:00
      endMinute: 1080,  // 18:00
      daysOff: [0],      // Dimanche
      night: false,
    };
    await setDoc(docRef, defaultParameters);
    return defaultParameters || {};
  }
};

// Mettre à jour les paramètres de l'utilisateur effectif
export const updateUserParameters = async (parameters) => {
  const userId = await getEffectiveUserId();
  if (!userId) {
    throw new Error("Utilisateur non connecté");
  }

  const docRef = doc(parametersCollection, userId);
  await updateDoc(docRef, parameters);
};